module.exports = __webpack_public_path__ + "img/arrow_yellow.f95407a5.gif";